import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useGetUserEntryQuery } from "services/auth/authService";
import { SchemaMods } from "types/carTypes";
import { loadExistingData } from "helpers/utils";
import PSPage from "components/globals/ui/layout/Page";
import { EntryLoading, EntryError } from "components/globals/EntryStates";
import { ProgressBarCars, FormStage } from "components/globals/forms/ORSFormLayout";
import { SuccessPane } from "components/modals/Panes";
import Pane from "components/modals/Pane";
import { FaPlus } from "react-icons/fa6";
import DeleteEntryUI from "components/globals/utils/DeleteEntryUI";
import {AddonForm} from "components/globals/forms/GarageCarAddon";

export default function CreateCarMods() {
	const { id } = useParams();
	const [loading, setLoading] = useState(true);
	const [success, setSuccess] = useState(false);
	const [newModPane, setNewModPane] = useState(false);
	const [postData, updatePostData] = useState(SchemaMods);

	const {
		data: existingEntryData,
		loading: entryLoading,
		error: entryError,
		refetch,
	} = useGetUserEntryQuery(`mods/${id}`);

	// TODO: convert to querying mods
	useEffect(() => {
		if (existingEntryData) {
			loadExistingData(updatePostData, SchemaMods, existingEntryData);
			setLoading(false);
		}
	}, [existingEntryData]);

	const hideNewPane = () => {
		setNewModPane(false);
	}

	const showSuccessPane = () => {
		setSuccess(true);
	}

	const onSuccess = () => {
		hideNewPane();
		refetch();
	}

	if (entryLoading) {
		return <EntryLoading />;
	}
	if (entryError) {
		return <EntryError msg="Failed to load." />;
	}

	return (
		<PSPage>
			<SuccessPane
				visible={success}
				title={`Successfully Updated Car: ${
					postData?.title
				}`}
			/>

			<div className="relative">

				<ProgressBarCars stage={5} id={id} />

				<div className="mt-[60px]">

					{/* panel 4: mods */}
					{!loading && (
						<FormStage 
							heading={`Update garage car`}
							subheading="Mods" 
							onSave={showSuccessPane}
							stage={5}
							stages={5}
							previousUrl={`/edit/car/associations/${id}`}
						>

							{/* list mods here */}
							{existingEntryData?.entries.map((mod) => (
								<div className="border-border border-[1px] rounded-default p-3 my-1 flex items-center space-between">
									<span className="grow text-[16px] ">{mod.type} - {mod.title}</span>
									<div>
										<DeleteEntryUI noText entry={mod} refetch onRefetch={refetch} />
									</div>
								</div>
							))}

							{/* always a create-new */}
							<NewMod onAddNewMod={setNewModPane} />

							<Pane visible={newModPane} onClose={hideNewPane}>
								<div className="relative mt-6">
									<AddonForm addonType="mod" id={id} onSuccess={onSuccess} />
								</div>
							</Pane>
							

						</FormStage>
					)}

				</div>
			</div>
		</PSPage>
	);
}

const NewMod = ({onAddNewMod}) => {
	return (
		<div 
			onClick={onAddNewMod}
			className="
				outline-3 
				outline-offset-2 
				outline-dashed 
				p-6 mt-6
				outline-grey 
				rounded-default 
				text-grey
				flex justify-center
				cursor-pointer">
			<div className="flex items-center">
				<FaPlus className="text-2xl " />
				<span className="block ml-2 text-lg ">NEW MOD</span>
			</div>
		</div>
	)
}

